import React from 'react';

export const filterOption = (input: any, option: any) => {
  const label = option?.label;
  if (React.isValidElement(label)) {
    // If label is a React element, we need to access its text content
    // @ts-ignore
    const labelText = label.props.children
      // @ts-ignore
      .filter((child) => typeof child === 'string')
      .join(' ');
    return labelText.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
  // Fallback for non-React element labels
  return String(label).toLowerCase().indexOf(input.toLowerCase()) >= 0;
};
